<template>
  <div class="QuizBackground">
    <!-- <MouseParallax id="ShapeTopLeft" class="QuizBackground_shape" > -->
      <img id="ShapeTopLeft" class="QuizBackground_shape" src="../../../public/static/images/shape.svg" />
    <!-- </MouseParallax> -->
    <!-- <MouseParallax id="ShapeTopRight" class="QuizBackground_shape"> -->
      <img id="ShapeTopRight" class="QuizBackground_shape" src="../../../public/static/images/shape.svg" />
    <!-- </MouseParallax> -->
    <!-- <MouseParallax id="ShapeBottomRight" class="QuizBackground_shape" > -->
      <img id="ShapeBottomRight" class="QuizBackground_shape" src="../../../public/static/images/shape.svg" />
    <!-- </MouseParallax> -->
    <!-- <MouseParallax id="ShapeBottomLeft" class="QuizBackground_shape" >  -->
      <img id="ShapeBottomLeft" class="QuizBackground_shape" src="../../../public/static/images/shape.svg" />
    <!-- </MouseParallax> -->

    <div class="QuizBackground_losange"></div>
  </div>
</template>

<script>
  import MouseParallax from "@/components/MouseParallax"

  export default {
    name: "QuizBackground",
    components: { MouseParallax }
  }
</script>

<style lang="stylus" scoped>
.QuizBackground

  position fixed
  top 0px
  left 0px
  right 0px
  bottom 0px
  width 100%
  height 100%
  background-color $s2
  transition 1s $ease

  &_losange

    position absolute
    top 50%
    left 50%
    width 80vw
    height 80vw
    background-color #EEF5FF
    transition 0.4s $ease, opacity 0.3s $ease
    opacity 0
    transform translate(-50%, -50%) rotate(-45deg) scale(0)

    @media $medium

      width 80vh
      height 80vh

  &_shape

    position absolute
    transition 1s $ease
    display block

    img

      width 100%

  #ShapeTopLeft

    width 355px
    height 355px
    top -177px
    left -90px

    @media $medium

      top -110px!important
      right auto!important
      bottom auto!important
      left -145px!important
      width 365px!important
      height 365px!important

  #ShapeBottomRight

    width 240px
    height 240px
    right -90px
    top 33%

    @media $medium
      
      top auto!important
      left auto!important
      bottom -95px!important
      right -150px!important
      width 300px!important
      height 300px!important

  #ShapeBottomLeft

    width 80px
    height 80px
    bottom 80px
    left 90px

    @media $medium

      transform scale(0)!important
      opacity 0!important

  #ShapeTopRight

    transform scale(0)
    height 80px
    width 80px
    top 80px
    right 90px
    opacity 0

    @media $medium

      transform scale(0)!important
      opacity 0!important

  &_white

    background-color white

    .QuizBackground_shape

      opacity 0.13

      @media $medium

        opacity 0
        transform scale(0.3)

    #ShapeTopLeft

      width 80px
      height 80px
      top 130px
      left 205px

    #ShapeBottomRight

      width 240px
      height 240px
      right -90px
      top 33%

    #ShapeBottomLeft

      width 355px
      height 355px
      bottom -140px
      left -120px

  &_withIllustration

    #ShapeTopLeft

      width 240px
      height 240px
      top 24%
      left -90px

    #ShapeBottomRight

      width 350px
      height 350px
      right -90px
      top 80%

    #ShapeBottomLeft

      transform scale(0.3)
      opacity 0

    #ShapeTopRight

      transform scale(1)
      opacity 1

  &_annexe

    .QuizBackground

      &_shape

        transform scale(0.3)
        opacity 0

      &_losange

        transform translate(-50%, -50%) rotate(-45deg) scale(1)
        opacity 1
        transition 1s $back, opacity 0s linear

</style>